/*document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".card-product [data-rental-request]")
    .forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        document.querySelector("html").classList.add("itg-scroll-lock");
        document.body.classList.add("sample");
        var form = document.querySelector(".custom-enquiry-form .contact-form");
        form.classList.add("custom-visible");

        // Find the product title
        var product = this.closest(".card-product").querySelector(
          ".card-heading.product-title"
        ).textContent;

        // Find the selected product option
        var selectedOption =
          this.closest(".card-product").querySelector(
            ".custom-select-option select"
          )?.value || "No option selected";

        // Add class to ContactForm-name
        // var contactFormName = document.getElementById("ContactForm-name");
        // contactFormName.classList.add("high");

        // Log the product and selected option
        // console.log("Product:", product);
        // console.log("Selected Option:", selectedOption);

        // Update product title input value
        document.querySelector(
          ".custom-enquiry-wrapper .product-title-input"
        ).value = product.trim();

        // Optionally set the selected option in another field if needed
        document.querySelector(
          ".custom-enquiry-wrapper .product-option-input"
        ).value = selectedOption.trim();

        const firstInput = form.querySelector("#ContactForm-name");
        if (firstInput) {
          firstInput.focus();
        }
      });
    });

  // Close the form when clicking outside of it
  document.addEventListener("click", function (event) {
    var form = document.querySelector(".contact-form");

    if (form && form.classList.contains("custom-visible")) {
      // Check if the click was inside the form or the button that opens it
      var isClickInsideForm = form.contains(event.target);
      var isClickOnButton = event.target.closest(
        ".card-product [data-rental-request]"
      );

      if (!isClickInsideForm && !isClickOnButton) {
        form.classList.remove("custom-visible");
        document.querySelector("html").classList.remove("itg-scroll-lock");
        document.body.classList.remove("sample");
      }
    }
  });

  // Close the form when clicking on #close-icon-btn
  document
    .getElementById("close-icon-btn")
    ?.addEventListener("click", function () {
      var form = document.querySelector(".contact-form");

      if (form) {
        form.classList.remove("custom-visible");
        document.querySelector("html").classList.remove("itg-scroll-lock");
        document.body.classList.remove("sample");
      }
    });
});*/

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".card-product [data-rental-request]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();

        var form = document.querySelector(".custom-enquiry-form .contact-form");

        if (form && form.style.display === "none") {
          form.style.display = ""; 
        }

        document.querySelector("html").classList.add("itg-scroll-lock");
        document.body.classList.add("sample");
        form.classList.add("custom-visible");

        // Find the product title
        var product = this.closest(".card-product").querySelector(
          ".card-heading.product-title"
        ).textContent;

        // Find the selected product option
        var selectedOption =
          this.closest(".card-product").querySelector(
            ".custom-select-option select"
          )?.value || "No option selected";

        // Update product title input value
        document.querySelector(
          ".custom-enquiry-wrapper .product-title-input"
        ).value = product.trim();

        // Optionally set the selected option in another field if needed
        document.querySelector(
          ".custom-enquiry-wrapper .product-option-input"
        ).value = selectedOption.trim();

        const firstInput = form.querySelector("#ContactForm-name");
        if (firstInput) {
          firstInput.focus();
        }
      });
    });

  // Close the form when clicking outside of it
  document.addEventListener("click", function (event) {
    var form = document.querySelector(".contact-form");

    if (form && form.classList.contains("custom-visible")) {
      // Check if the click was inside the form or the button that opens it
      var isClickInsideForm = form.contains(event.target);
      var isClickOnButton = event.target.closest(
        ".card-product [data-rental-request]"
      );

      // If the click is outside the form and the button
      if (!isClickInsideForm && !isClickOnButton) {
        form.classList.remove("custom-visible");
        document.querySelector("html").classList.remove("itg-scroll-lock");
        document.body.classList.remove("sample");

        // Optionally reset the display style of the form
        form.style.display = "none"; // Hide the form if clicked outside
      }
    }
  });

  // Close the form when clicking on #close-icon-btn
  document
    .getElementById("close-icon-btn")
    .addEventListener("click", function () {
      var form = document.querySelector(".contact-form");

      if (form) {
        form.classList.remove("custom-visible");
        document.querySelector("html").classList.remove("itg-scroll-lock");
        document.body.classList.remove("sample");

        // Optionally reset the display style of the form
        form.style.display = "none"; // Hide the form when close button is clicked
      }
    });
});


$(document).ready(function () {
  // $(".card-product [data-rental-request]").on("click", function (event) {
  //   event.preventDefault();
  //   var product = $(this)
  //     .closest(".card-product")
  //     .find(".card-heading .product-title")
  //     .text();
  //   console.log(product);
  //   $("html").addClass("itg-scroll-lock");
  //   $("body").addClass("sample");
  //   $("#ContactForm-name").addClass("high");

  //   event.stopPropagation();
  //   $(".custom-enquiry-wrapper .product-title-input").val(product);

  //   setTimeout(function () {
  //     $("#ContactForm-name")
  //       .focus()
  //       .scrollIntoView({ behavior: "smooth", block: "center" });
  //   }, 500);
  // });

  // $(document).on("click", function (event) {
  //   // Check if the click target is not within the form
  //   if (!$(event.target).closest(".contact-form").length) {
  //     $("html").removeClass("itg-scroll-lock");
  //     $("body").removeClass("sample");
  //   }
  // });

  // image slider
  // var swiper = new Swiper(".itg_mySwiper", {
  //   slidesPerView: 3,
  //   spaceBetween: 30,
  //   loop: true,
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true,
  //   },
  //   breakpoints: {
  //     0: {
  //       slidesPerView: 1,
  //     },
  //     320: {
  //       slidesPerView: 1,
  //     },
  //     767: {
  //       slidesPerView: 2,
  //     },
  //     1024: {
  //       slidesPerView: 3,
  //     },
  //   },
  // });

  // media-with-text-slider
  var swiper = new Swiper(".media-with-text-Swiper", {
    slidesPerView: 1,
    spaceBetween: 40,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  // feature text
  $(".features_textSlide").slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var slidesPerPage = window.slidesPerView || 3; // Fallback to default if not set

  var swiper = new Swiper(".itg_mySwiper", {
    slidesPerView: slidesPerPage,
    spaceBetween: 30,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      320: {
        slidesPerView: 1,
      },
      767: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: slidesPerPage,
      },
    },
  });
});

/* ============================================================
   Samita/Globo RFQ — re-scan AJAX-injected product cards.
   The app only scans the DOM on initial load, so cards fetched
   later (e.g. <product-recommendations> "Related products")
   never get their Add To Quote button. When late-loaded cards
   containing the .g-collection-atc mount appear without an app
   button, re-run GRFQApp.initialize() once (the app skips items
   it already processed via its rfq-collection-loaded marker).
   ============================================================ */
(function () {
  var rescans = 0;

  function needsRescan(root) {
    var mounts = (root || document).querySelectorAll('.g-collection-atc');
    for (var i = 0; i < mounts.length; i++) {
      if (!mounts[i].querySelector('.rfq-collection-btn, button, a')) return true;
    }
    return false;
  }

  function rescan() {
    if (rescans >= 5) return;
    if (window.GRFQApp && typeof window.GRFQApp.initialize === 'function') {
      rescans++;
      try { window.GRFQApp.initialize(); } catch (e) { /* app not ready */ }
    } else {
      setTimeout(rescan, 1000);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; if (needsRescan()) rescan(); }, 400);
  }

  function watch() {
    var hosts = document.querySelectorAll('product-recommendations');
    if (!hosts.length) return;
    hosts.forEach(function (el) {
      if (needsRescan(el)) schedule();
      new MutationObserver(function () {
        if (needsRescan(el)) schedule();
      }).observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
